<template>
  <div class="app-container pwdBox">
    <el-form
      ref="form"
      :model="data"
      status-icon
      :rules="formRules"
      @keyup.enter.native="submit"
    >
      <el-form-item label="原密码" prop="OldPwd">
        <el-input v-model.trim="data.OldPwd" />
      </el-form-item>
      <el-form-item label="新密码" prop="NewPwd">
        <el-input v-model.trim="data.NewPwd" />
      </el-form-item>
      <el-form-item label="确认密码" prop="ConfirmPwd">
        <el-input v-model.trim="data.ConfirmPwd" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import api from "@/api/sy/user";

export default {
  data() {
    let validator = (rule, value, callback) => {
      if (this.data.NewPwd == "" || this.data.ConfirmPwd == "") {
        callback();
      }
      if (this.data.NewPwd != this.data.ConfirmPwd) {
        callback("密码不一致");
      } else {
        callback();
      }
    };
    return {
      data: {
        OldPwd: "",
        NewPwd: "",
        ConfirmPwd: "",
      },
      formRules: {
        OldPwd: [{ required: true, message: "原密码不能为空" }],
        NewPwd: [
          { required: true, message: "新密码不能为空" },
          { validator: validator },
        ],
        ConfirmPwd: [
          { required: true, message: "确认密码不能为空" },
          { validator: validator },
        ],
      },
    };
  },
  methods: {
    submit() {
      let form = this.formValidate();
      form.then((valid) => {
        if (!valid) {
          return;
        }
        api.changePwd(this.data).then((res) => {

          if (res.Code == 1) {
            this.$message.error(res.Msg);
          } else {
            this.$message({
              message: res.Msg,
              type: "success",
              duration: 3000,
            });
          }
        });
      });
    },
    formValidate() {
      return this.$refs.form
        .validate()
        .then((valid) => {
          return valid;
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "请检查相关字段（红色）填写是否规范",
            type: "warning",
            position: "top-left",
          });
          return false;
        });
    },
  },
};
</script>
<style>
.pwdBox{
  width: 400px !important;
}
</style>